import { render } from "./SiteTemplateThumb.vue?vue&type=template&id=67433912"
import script from "./SiteTemplateThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteTemplateThumb.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SiteTemplateThumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67433912"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67433912', __exports__)) {
    api.reload('67433912', __exports__)
  }
  
  module.hot.accept("./SiteTemplateThumb.vue?vue&type=template&id=67433912", () => {
    api.rerender('67433912', render)
  })

}


export default __exports__